import React, { Component } from 'react';
import { CSVLink } from "react-csv";
import map from 'lodash/map';
import get from 'lodash/get';
import moment from 'moment';
import unionBy from 'lodash/unionBy';
import isEmpty from 'lodash/isEmpty';
import './ExportToCsv.css';


const exportMessage = 'Export to CSV';
class ExportToCSV extends Component {

  getUserName = (item) => {
    if (!isEmpty(item.firstName) || !isEmpty(item.lastName)) {
      return `${item.firstName} ${item.lastName}`
    }
    return 'NA';
  }

  getEOLinkedInfo = (object) => {
    if(object.parentTask && object.parentTask.item) {
        const parentTask = object.parentTask.item;
        return parentTask.isDeleted !== undefined ? `${ parentTask.title} ( Archived )` : parentTask.title;
    }
    return null;

}

getActionStatus = (item) => {
    return item.isDeleted ? `Archived ` : item.completedDate ? 'Completed' : 'Active';      
}

  getData = (data) => {
    const csvData = [];
      map(data, (d) => {
        let eachUserRow = {
          title: d.title,
          createOn: moment(d.createdOn).format('MM/DD/YYYY'),
          createdBy: this.getUserName(d.userId),
          linkedEO: this.getEOLinkedInfo(d),
          actionStatus: this.getActionStatus(d)
        }
        csvData.push(eachUserRow);
      });
    return csvData;
  }

  render() {
    let UsersStaticHeaders = [
      { label: "Action Title", key: "title" },
      { label: "Date Created", key: "createOn" },
      { label: "Created by", key: "createdBy" },
      { label: "Linked EO", key: "linkedEO" },
      { label: "Action Status", key: "actionStatus" }
    ];

    const { Analytics } = this.props;
    return (
      <div className="col-lg-12 col-md-12 col-sm-12 tool-list-font text-right">
        <span className="linkclass" style={{ lineHeight: '42px' }}><i className="flaticon-export" style={{ marginRight: '8px' }}></i>
          <CSVLink
            data={ this.getData(Analytics) }
            headers={UsersStaticHeaders}
            filename={`Actions Analytics-${moment().format("MM/DD/YYYY")}.csv`}
            separator={","}
            target="_blank"
          >{exportMessage}</CSVLink>
        </span>
      </div>
    )
  }
}

export default ExportToCSV;